var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-box"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"clip",attrs:{"id":"context"}}),_c('span',{staticClass:"tips-number"},[_vm._v("已售"+_vm._s(55)+"%")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }